import React from 'react'
import { CircularProgress, Box } from '@mui/material'
import { useTranslation } from 'react-i18next'
import RsmPagination, {
  RsmPaginationPageSizes,
} from 'src/rsmCoreComponents/components/RsmPagination/RsmPagination'
import NoSearchFound from 'src/rsmCoreComponents/components/NoSearchFound/NoSearchFound'
import { PbiReportDefinitionViewModel } from '@rsmus/ecp-userservice'
import { Styles } from 'src/types'
import Unavailable from '../../pages/Unavailable/Unavailable'
import PbiReportsTable from './PbiReportsTable'

interface AdminPbiReportResultsProps {
  reportsData: { data: PbiReportDefinitionViewModel[]; totalRows: number }
  isReportError: boolean
  isMounted: boolean
  pageNumber: number
  pageSize: RsmPaginationPageSizes
  onPageChange: (pageNumber: number, pageSize: RsmPaginationPageSizes) => void
  sortColumn: string
  sortDirection: 'asc' | 'desc'
  onSorting: (columnName: string, direction: 'asc' | 'desc') => void
  onEditReport?: (report: PbiReportDefinitionViewModel) => void
  onRemoveReport?: (report: PbiReportDefinitionViewModel) => void
}
const styles: Styles = {
  container: () => ({
    display: 'flex',
    justifyContent: 'center',
    verticalAlign: 'middle',
    height: '2rem',
    marginTop: '2rem',
  }),
}

const AdminPbiReportResults = ({
  reportsData,
  isReportError,
  isMounted,
  pageNumber,
  pageSize,
  onPageChange,
  onSorting,
  sortColumn,
  sortDirection,
  onEditReport,
  onRemoveReport,
}: AdminPbiReportResultsProps) => {
  const { t } = useTranslation()

  if (isReportError) {
    return <Unavailable />
  }

  if (isMounted && (!reportsData || reportsData.data.length === 0)) {
    return (
      <NoSearchFound
        title={t('AdminSettingsForm.PbiReportColumns.NoReports')}
        subTitle=""
      />
    )
  }

  if (reportsData && reportsData.data && reportsData.data.length > 0) {
    return (
      <>
        <PbiReportsTable
          ReportsData={reportsData}
          onSort={onSorting}
          sortColumn={sortColumn}
          sortDirection={sortDirection}
          isMounted={isMounted}
          onEditReport={onEditReport}
          onRemoveReport={onRemoveReport}
        />

        <RsmPagination
          pageNumber={pageNumber}
          pageSize={pageSize}
          totalRows={reportsData?.totalRows ?? 0}
          onPageChange={onPageChange}
        />
      </>
    )
  }

  return (
    <Box sx={styles.container} aria-busy="true">
      <CircularProgress color="secondary" data-testid="Spn_Invoices_Loading" />
    </Box>
  )
}

export default AdminPbiReportResults
